import { useEffect, useState } from 'react'
import { BigNumber } from 'ethers'
import { CHAIN_ID_NAMES, ChainId, DEFAULT_CHAIN } from '../constants'
import { useEthers } from './useEthers'

export type TimeReleaseClaim = {
  amount1: BigNumber
  amount2: BigNumber
  claimable1: BigNumber
  claimable2: BigNumber
  proof: string[]
}

export type TimeRelease = {
  id: number
  address: string
  claim?: TimeReleaseClaim
  option1StartBlock: number
  option1EndBlock: number
  option1StopBlock: number
  option2StartBlock: number
  option2EndBlock: number
  option2StopBlock: number
  tokenTotal1: BigNumber
  tokenTotal2: BigNumber
  startDate: Date
}

export function useApiMerkleTimeRelease() {
  const { chainId = DEFAULT_CHAIN, account } = useEthers()
  const [timeReleases, setTimeReleases] = useState([] as TimeRelease[])

  useEffect(() => {
    async function getTimeRelease() {
      try {
        const res = await fetch(
          `https://${chainId === ChainId.Kovan ? 'kovan-api' : 'api'}.integral.link/api/v1/time-releases?network=${
            CHAIN_ID_NAMES[chainId]
          }&address=${account}`
        )
        const json = await res.json()
        if (json && json.success) {
          setTimeReleases(json.data)
        }
      } catch (e) {
        console.error(e)
      }
    }
    getTimeRelease()
  }, [account, chainId])
  return { timeReleases }
}
